import { useState } from 'react';
import Button from '../ui/Button';
import './CopyJsonButton.css';

export default function CopyJsonButton({ brief, variant = 'secondary', size = 'sm' }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const exportData = {
      ...brief,
      _meta: {
        exportedAt: new Date().toISOString(),
        sourceUrl: window.location.href
      }
    };

    try {
      await navigator.clipboard.writeText(JSON.stringify(exportData, null, 2));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleCopy}
      className={`copy-json-btn ${copied ? 'copy-json-btn--copied' : ''}`}
    >
      {copied ? (
        <>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="copy-json-btn__icon">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          Copied!
        </>
      ) : (
        <>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="copy-json-btn__icon">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
          Copy JSON
        </>
      )}
    </Button>
  );
}
